// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"e5bfc777","521":"939431a0"}[chunkId] + ".chunk.js";
};